import React, { useLayoutEffect, useRef, useState } from "react";

import { createPortal } from 'react-dom';

export default ({children, size="sm", style="outline", busy, onClick}) => {

  const buttonRef = useRef();

  return <button
          onClick={onClick}
          ref={buttonRef}
          type="button"
          class={`button button--${size} button--${style}`}
          aria-busy={busy}
          is="custom-button" >
          { children }
          </button>
}
